import { Component, OnInit } from '@angular/core';
import { RoutingService } from '@scripts/woo_services.module/RoutingService';
import { DashboardTab, wooId } from '@scripts/woo_services.module/shared-types';
import { ModalService } from '@src/shared/modal/modal.service';
import { InvoiceService } from '../../../woo_services.module/InvoiceService';

@Component({
  selector: 'invoice-attestation',
  templateUrl: './invoice-attestation.component.html',
  styles: [
    `
      .no-margin {
        margin: 0;
        padding-bottom: 2rem;
      }
    `,
  ],
  standalone: false,
})
export class InvoiceAttestation implements OnInit {
  TableType = TableType;

  invoices = {
    approved: [],
    waitingForApproval: [],
  };
  loadingInvoices = {
    approved: true,
    waitingForApproval: true,
  };

  constructor(
    private invoiceService: InvoiceService,
    private modalService: ModalService,
    private routingService: RoutingService,
  ) {}

  async ngOnInit(): Promise<void> {
    await this.loadInvoices();
  }

  async loadInvoices(): Promise<void> {
    this.invoices.waitingForApproval = await this.invoiceService.getAwaitingAttest();
    this.loadingInvoices.waitingForApproval = false;
    this.invoices.approved = await this.invoiceService.getSentCreditInvoices();
    this.loadingInvoices.approved = false;
  }

  async attestInvoice(invoiceId: wooId): Promise<void> {
    this.modalService.openConfirm(this.modalContent).then((response) => {
      if (response.confirm) {
        this.invoiceService.attestInvoice(invoiceId).then(() => {
          this.loadInvoices();
        });
      }
    });
  }

  showCampaign(campaignId: wooId): void {
    this.routingService.openAndGoDashboardTab(campaignId, DashboardTab.details);
  }

  modalContent = {
    title: 'Godkänn kreditfaktura',
    texts: ['Är du säker på att du vill godkänna kreditfakturan?'],
    confirmLabel: 'Godkänn',
    cancelLabel: 'Avbryt',
  };
}

export enum TableType {
  Approved = 'approved',
  WaitingForApproval = 'waitingForApproval',
}
